import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
import { IconSize } from '@foundation/Icon/IconSize';

import IconArrowSlideOut12 from './IconArrowSlideOut12';
import IconArrowSlideOut16 from './IconArrowSlideOut16';
import IconArrowSlideOut20 from './IconArrowSlideOut20';
import IconArrowSlideOut24 from './IconArrowSlideOut24';
import IconArrowSlideOut32 from './IconArrowSlideOut32';

/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
const IconArrowSlideOut = (props: GeneratedIconProps): ReactElement<GeneratedIconProps> => {
    const size = props.size || IconSize.Size16;
    return (
        <span>
            {size === IconSize.Size12 && !props.filled && <IconArrowSlideOut12 {...props} />}
            {size === IconSize.Size16 && !props.filled && <IconArrowSlideOut16 {...props} />}
            {size === IconSize.Size20 && !props.filled && <IconArrowSlideOut20 {...props} />}
            {size === IconSize.Size24 && !props.filled && <IconArrowSlideOut24 {...props} />}
            {size === IconSize.Size32 && !props.filled && <IconArrowSlideOut32 {...props} />}
        </span>
    );
};
IconArrowSlideOut.displayName = 'FondueIconArrowSlideOut';

export default memo(IconArrowSlideOut);
